import { ErrorResponse } from '../../../lib/basicRepository';
import { restApi } from '../../../services/api';
import { BatchDeleteOrderProductsDto } from './dtos/batch-delete-order-products.dto';
import { CopyToExistingOrderDTO } from './dtos/copy-to-existing-order.dto';
import { CopyToNewOrderDTO } from './dtos/copy-to-new-order.dto';
import { OrderProductsRepository } from './interfaces/order-products-repository.types';

export const orderProductsRepository = (orderId: string): OrderProductsRepository => {
  const repository = {
    copyToNewOrder: (data: CopyToNewOrderDTO) =>
      restApi.post<void, ErrorResponse>(`orders/${orderId}/order-products/batch-copy-to-new`, data),
    copyToExistingOrder: (data: CopyToExistingOrderDTO) =>
      restApi.post<void, ErrorResponse>(
        `orders/${orderId}/order-products/batch-copy-to-existing`,
        data,
      ),
    batchDelete: (data: BatchDeleteOrderProductsDto) =>
      restApi.delete<void, ErrorResponse>(`orders/${orderId}/order-products/batch`, {}, { data }),
  };

  return repository;
};
